"use client";

import * as React from "react";
const BadgeList = ({
  children,
  dataTest,
  id
}) => {
  return /*#__PURE__*/React.createElement("ul", {
    className: "m-0 flex flex-col p-0",
    "data-test": dataTest,
    id: id
  }, children);
};
export { default as BadgeListItem } from "./BadgeListItem";
export default BadgeList;